import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// UI theme for the live-show editor. Persisted per browser (production
// operators keep their own preference across shows). Default is 'dark'
// to match the app's original look; 'light' is for bright locations
// where the dark UI is hard to read.
export const useThemeStore = create(
  persist(
    (set, get) => ({
      theme: 'dark', // 'dark' | 'light'

      setTheme: (theme) => set({ theme: theme === 'light' ? 'light' : 'dark' }),

      toggleTheme: () => set({ theme: get().theme === 'light' ? 'dark' : 'light' }),
    }),
    {
      name: 'mission-control-theme',
      partialize: (state) => ({ theme: state.theme }),
    }
  )
);
